import ShowAdditionalImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/additionalImages/ShowAdditionalImages';
import AdjusterDocumentsImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/AdjusterDocumentsImages';
import ShowAdjusterDocumentImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/ShowAdjusterDocumentImages';
import BodyFlowGuidePage from '@/modules/adjusterReportModules/Insurer-information/components/images/vehicleImages/bodyFlowGuide/BodyFlowGuidePage';
import BodyAdjusterAttachedImages from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/AccidentAttachments/BodyAdjusterAttachedImages';
import BodyAdjusterImagesTabs from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/BodyAdjusterImagesTabs';
import BodyImageFlow from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/bodyImageFlow/BodyImageFlow';
import BodyDamagedPoints from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/vehicleImages/bodyDamagedPoints/BodyDamagedPoints';
import BodyServerDamagedPointsPage from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/vehicleImages/bodyServerDamagedPoints/BodyServerDamagedPointsPage';
import BodyVehicleImagePreview from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/vehicleImages/bodyVehicleDamageImagePreview/BodyVehicleImagePreview';
import BodyVehicleImagesShow from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/vehicleImages/bodyVehicleDamageServerImagePreview/BodyVehicleImagesShow';
import BodyVehicleServerImagePreview from '@/modules/adjusterReportModules/Insurer-information/pages/images/adjusterImages/vehicleImages/bodyVehicleDamageServerImagePreview/BodyVehicleServerImagePreview';
import BodyCustomerAttachedImages from '@/modules/adjusterReportModules/Insurer-information/pages/images/bodyCustomerImages/BodyCustomerAttachedImages';
import BodyCustomerDocumentsImages from '@/modules/adjusterReportModules/Insurer-information/pages/images/bodyCustomerImages/BodyCustomerDocumentsImages';
import BodyCustomerImagesTabs from '@/modules/adjusterReportModules/Insurer-information/pages/images/bodyCustomerImages/BodyCustomerImagesTabs';
import BodyCustomerVehicleImages from '@/modules/adjusterReportModules/Insurer-information/pages/images/bodyCustomerImages/BodyCustomerVehicleImages';
import BodyTabImagesPage from '@/modules/adjusterReportModules/Insurer-information/pages/images/bodyTabImages/BodyTabImages';
import BodyCorrectiveImages from '@/modules/adjusterReportModules/Insurer-information/pages/images/correctiveImages/BodyCorrectiveImages';
import BodySignaturePage from '@/modules/adjusterReportModules/Insurer-information/pages/images/signature/BodySignaturePage';
import { ADJUSTER_REPORT_BODY_DAMAGE_PATHS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { Outlet, RouteObject } from 'react-router-dom';

const VEHICLE_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE.base,
    children: [
      {
        element: <BodyDamagedPoints />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .serverDamagedPoints,
        element: <BodyServerDamagedPointsPage />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .takePhotoGuide,
        element: <BodyFlowGuidePage />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .imageFlow,
        element: <BodyImageFlow />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .imageFlowSignature,
        element: <BodySignaturePage editable={false} />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .previewImages,
        element: <BodyVehicleImagePreview />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .serverPreviewImages,
        element: <BodyVehicleServerImagePreview />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.VEHICLE
          .showServerPreviewImages,
        element: <BodyVehicleImagesShow />,
      },
    ],
  },
];

const ADJUSTER_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.base,
    element: <Outlet />,
    children: [
      {
        element: <BodyAdjusterImagesTabs />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.DOCUMENT.edit,
        element: <AdjusterDocumentsImages userType="body" />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.DOCUMENT.show,
        element: <ShowAdjusterDocumentImages userType="body" />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.ADDITIONAL.edit,
        element: <BodyAdjusterAttachedImages />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.ADJUSTER.ADDITIONAL.show,
        element: <ShowAdditionalImages userType="body" />,
      },
      ...VEHICLE_IMAGES_ROUTES,
    ],
  },
];

const CUSTOMER_IMAGES_ROUTES: RouteObject[] = [
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.CUSTOMER.base,
    element: <Outlet />,
    children: [
      {
        element: <BodyCustomerImagesTabs />,
        index: true,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.CUSTOMER.document,
        element: <BodyCustomerDocumentsImages />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.CUSTOMER.additional,
        element: <BodyCustomerAttachedImages />,
      },
      {
        path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.CUSTOMER.vehicleImages,
        children: [
          {
            element: <BodyCustomerVehicleImages />,
            index: true,
          },
        ],
      },
    ],
  },
];

export const ADJUSTER_REPORT_BODY_DAMAGE_IMAGES_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <BodyTabImagesPage />,
  },
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.SIGNATURE.edit,
    element: <BodySignaturePage editable />,
  },
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.SIGNATURE.show,
    element: <BodySignaturePage editable={false} />,
  },
  {
    path: ADJUSTER_REPORT_BODY_DAMAGE_PATHS.IMAGES.corrective,
    element: <BodyCorrectiveImages />,
  },
  ...ADJUSTER_IMAGES_ROUTES,
  ...CUSTOMER_IMAGES_ROUTES,
];
